import { ResetPasswordInputModel } from "./reset-password.model";

export class CreateAccountModel extends ResetPasswordInputModel {
  username: string = '';
  firstname: string = '';
  lastname: string = '';
  user_type: string = '';
  timezone: string = '';
  address: UserAddressModel = new UserAddressModel();
  zip_code?: string = '';
  phone_number: string = '';
  country_code: string = '';
  org_name: string = '';
  customer_number:string = '';

}

export class UserAddressModel {
  street_address1: string = '';
  street_address2: string = '';
  state: string = '';
  city: string = '';
  zip_code: string = '';
}
